
let api_url;

if (import.meta.env.MODE && import.meta.env.MODE === "development") {
    api_url = "https://api-wsfr-perf.io.differangles.fr";
} else if (window.location.hostname.includes("worldskills-france.org")) {
    api_url = "https://api.victoire.worldskills-france.org";
} else if (window.location.hostname.includes("localhost")) {
    api_url = "https://api-wsfr-perf.io.differangles.fr";
} else {
    api_url = "https://api-wsfr-perf.io.differangles.fr";
}

export default api_url;